import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'resFilter'
})
export class ResFilterPipe implements PipeTransform {

  transform(objs: any[], id: string): any[] {
    return objs.filter(o => o.idResource == id)
  }

}
